export const ADDITIONAL_ENROLLMENT_STATUSES = [
  { value: 'promocion_pendiente', label: 'Promoción Pendiente' },
  { value: 'desercion', label: 'Deserción' },
  { value: 'aplazado', label: 'Aplazado' },
  { value: 'no_aprobado', label: 'No Aprobado' },
];

export function getEnrollmentStatusLabel(status) {
  return ADDITIONAL_ENROLLMENT_STATUSES.find(option => option.value === status)?.label || status || '—';
}

export function getAdditionalEnrollmentStatuses(type) {
  if (type === 'course') return ADDITIONAL_ENROLLMENT_STATUSES.filter((option) => option.value === 'no_aprobado');
  return ADDITIONAL_ENROLLMENT_STATUSES.filter(
    (option) => option.value !== 'no_aprobado' || !type || type === 'grade'
  );
}

export function isEnrollmentAccessBlocked(status, type) {
  // En cursos, promovido no bloquea esta vista; No aprobado conserva esa regla.
  if (type === 'course') return false;
  return ['desercion', 'aplazado', 'no_aprobado'].includes(status);
}
